import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { setCapitalStructureDividendsShowHistoricYears } from '@app/core/store/ui-values-slice';
import ProjectRoutesWrapper from '@app/modules/projects/project-routes-wrapper/ProjectRoutesWrapper';
import { RouteConstants } from '@app/modules/projects/RouteConstants';
import { ContentHeader } from '@app/shared/layout/content-header/ContentHeader';
import HighlightEditableCells from '@app/shared/components/highlight-editable-cells/HighlightEditableCells';
import CurrencyLabel from '@app/shared/components/currency-label/CurrencyLabel';
import { ShowHistoricDataToggle } from '@app/shared/components/show-historic-data/ShowHistoricDataToggle';
import { CapitalStructureNavigation } from '../../CapitalStructureNavigation';
import { DividendNavigationControls } from '../../controls/DividendNavigationControls';
import { useLocale } from '@app/core/hooks/useLocale';
import { Outlet } from 'react-router-dom';
import useGetHistoricDividendYears from '@app/shared/hooks/useGetHistoricDividendYears';

export const DividendsPage = () => {
  const { l } = useLocale();
  const dispatch = useAppDispatch();
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.capitalStructure.dividends.showHistoricYears
  );
  const historicDividendYears = useGetHistoricDividendYears();
  const shouldShowHistoricData = historicDividendYears.length > 0;

  return (
    <ProjectRoutesWrapper.PageLayout
      key={RouteConstants.Dividends}
      contentHeader={
        <ContentHeader
          title={l('_Dividends')}
          navigation={<CapitalStructureNavigation />}
          subNavigation={<DividendNavigationControls />}
          controlOptions={
            <>
              <CurrencyLabel />
              <HighlightEditableCells />
              <ShowHistoricDataToggle
                checked={showHistoricDataColumns}
                onToggle={(checked) =>
                  dispatch(setCapitalStructureDividendsShowHistoricYears(checked))
                }
                shouldShow={shouldShowHistoricData}
              />
            </>
          }
        />
      }
      pageName={RouteConstants.Dividends}>
      <Outlet />
    </ProjectRoutesWrapper.PageLayout>
  );
};
